<template>
  <div>
    <div class="iframe-container" v-if="this.$store.state.userCurrentCompany">
      <iframe :src=this.dashboardUrl id='dashboard-frame' width='1200px' height='850px' allowfullscreen frameborder='0'></iframe>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Dashboard',
  components: {
  },
  async created () {
  },
  mounted () {
  },
  methods: {
  },
  computed: {
    dashboardUrl () {
      return 'https://bi.responsegrid.com/bi/site/dashboards/dashboards/7072c85c-8aaf-4cf7-b3f0-8f509999cdfb/ResponseGrid%20Operations/ResponseGrid%20BI%20Dashboard?isembed=true&hassso=true&externallogin=oauth&hide_header=true&CompanyId=' + this.$store.state.userCurrentCompany.companyId
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cert {
  position: absolute;
  top: -2px;
  left: -2px;
  color: rgb(89, 165, 89);
}
.card-body > h5 {
  cursor: pointer;
  color: rgb(89, 165, 89);
  font-size: 1.8em;
  font-weight: 800;
  margin:.1em;
}
.dashboard-hud {
  position: absolute;
  top: 50px;
  width: calc(100% - 90px);
  background-color: #09253a;
}
.dashboard-hud .card{
  background: rgba(0,0,0,0.5);
  border-radius: 30px;
  margin: 0 25px;
  box-shadow: inset 0 1px 2px rgba(0,0,0,0.2), 0 1px 0 rgba(255,255,255,0.1);
  overflow: visible;
  -webkit-transition: ease-out 0.3s;
  -moz-transition: ease-out 0.3s;
  transition: ease-out 0.3s;
}
.dashboard-hud .card:hover{
  box-shadow: inset 400px 0 0 0 #007bff;
  color: #fff;
  text-decoration: none;
}
.dashboard-hud .card .card-body {
  -webkit-transition: ease-out 0.4s;
  -moz-transition: ease-out 0.4s;
  transition: ease-out 0.4s;
}
.dashboard-hud .card:hover .card-body{
  padding-left: 0 !important;
  margin-left: -15px;
}
.dashboard-hud .card:hover .card-body:after{
  font-family: "fontawesome";
  content: "\f061";
  width: 20px;
  height: 20px;
  display: block;
  right: 5px;
  position: absolute;
}
.dashboard-hud .status-badge {
  position: absolute;
  top: -5px;
  left: -1px;
  z-index: 100;
}
.statistics-container {
  background-color: #fff;
  border: 2px solid lightgray;
  border-radius: 10px;
  padding:.1em .7em 0;
}
.statistics-container > label {
  font-size: small;
  margin:.1em;
}

.statistics-container > h5 {
  color: rgb(89, 165, 89);
  font-weight: 800;
  margin:.1em;
}
.iframe-container {
  position: relative;
  overflow: hidden;
  width: calc(100% - 4px);
  height: calc(100vh - 45px);
}
.iframe-container #dashboard-frame {
  position: relative;
  overflow: hidden;
  width: calc(100% - 3px);
  height: calc(100vh - 45px);
}
</style>



// WEBPACK FOOTER //
// src/views/Bold-Dashboard.vue